import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export interface LoginResponse {
  success: boolean;
  data: {
    user: {
      id: number;
      name: string;
      email: string;
      role: string;
    };
    token: string;
  };
}

export interface MeResponse {
  success: boolean;
  data: {
    user: {
      id: number;
      name: string;
      email: string;
      role: string;
      is_active: boolean;
      last_login_at: string;
      created_at: string;
    };
  };
}

export const authApi = {
  login: async (email: string, password: string): Promise<{ user: LoginResponse['data']['user']; token: string }> => {
    const response = await api.post<LoginResponse>('/auth/login', { email, password });
    return response.data.data;
  },

  me: async (): Promise<MeResponse['data']['user']> => {
    const response = await api.get<MeResponse>('/auth/me');
    return response.data.data.user;
  },

  logout: (): void => {
    localStorage.removeItem('token');
  },
};

export default api;
